import React from 'react';
import ModuleGate from '../../components/ModuleGate';
import MCAWorkspace from '../mca/MCAWorkspace';

export default function MCAPage() {
  const token = localStorage.getItem('token');
  return (
    <ModuleGate moduleKey="mca_workspace" moduleName="MCA Workspace" token={token}>
      <MCAWorkspace />
    </ModuleGate>
  );
}
